import React from "react";
import styled, { css } from "styled-components";
import { Link, useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import cl from "classnames";

export default function NavSelect({ list, isHidden = true }) {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  return (
    <StyledNavSelect $isHidden={isHidden}>
      {list.map((i) => (
        <div key={i.id}>
          <Link
            to={i.to}
            className={cl({
              active: i.to === pathname,
            })}
          >
            {t(i.title)}
          </Link>
        </div>
      ))}
    </StyledNavSelect>
  );
}

const StyledNavSelect = styled.div`
  position: absolute;
  background-color: var(--dark-blue);
  bottom: -43px;
  transform-origin: center top;
  transform: translateY(100%) scaleY(1);
  left: 0;
  z-index: 4;
  width: auto;
  transition: 0.4s ease;
  opacity: 1;
  visibility: visible;
  pointer-events: unset;
  box-shadow: 0px 5px 12px 4px rgba(8, 0, 115, 0.15);

  div {
    padding: 0 35px;

    a {
      position: relative;
      white-space: nowrap;
      display: inline-block;
      width: 100%;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 22px; /* 146.667% */
      padding: 15px 0;
      border-bottom: 1px solid var(--border);
      transition: 0.4s ease;

      &::after {
        content: "";
        position: absolute;
        width: 0%;
        height: 1px;
        left: calc(50% - 1px);
        transform: translateX(-49.5%);
        bottom: -1px;
        background-color: var(--extra-light-blue);
        transition: 0.4s ease;
      }

      &:hover {
        color: var(--extra-light-blue);

        &::after {
          width: 100%;
        }
      }

      &.active {
        color: var(--extra-light-blue);
        border-color: var(--extra-light-blue);
      }
    }

    &:last-of-type {
      a {
        border: 0;

        &::after {
          display: none;
        }
      }
    }
  }

  ${({ $isHidden }) =>
    $isHidden &&
    css`
      transform: translateY(100%) scaleY(0);
      opacity: 0;
      visibility: hidden;
      pointer-events: none;
    `}
`;
